import { render, staticRenderFns } from "./RulesCategories.vue?vue&type=template&id=284b14ae"
import script from "./RulesCategories.vue?vue&type=script&lang=js"
export * from "./RulesCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports